module.exports = __webpack_public_path__ + "media/images/captive_portal/SkillManagement-svg-84f27bde238101c74f4d7dc2ea468dff.svg";